/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react/display-name */
import React, { memo } from "react";
import PropTypes from "prop-types";
import { createGlobalStyle } from "styled-components";
import { normalize } from "polished";
import { StaticQuery, graphql, Link } from "gatsby";
import theme from "../../theme";
import { Box, Flex } from "rebass";
import Menu from "./Menu";
import { Background as _Background } from "./Background";
import { Marquee } from "./Marquee";

const GlobalStyles = createGlobalStyle`
${normalize};
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:400,700&display=swap');
@import url('https://rsms.me/inter/inter.css');

body {
  font-family: Inter, -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
  background-color: ${theme.colors.bottom};
  min-height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 1.5;
  text-rendering: optimizeSpeed;
  font-display: swap;
}
html, body, div, article, section, main, footer, header, figcaption, form, input, fieldset, legend, pre, code, a, h1, h2, h3, h4, h5, h6, p, ul, ol, li {
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: inherit;
}
p {
  margin: 0 0 1em;
}
figure {
  margin: 0;
}
`;

const Background = memo(() => <_Background />);

const Layout = ({ children, invertMenuLogo, noPadding }) => {
  return (
    <StaticQuery
      query={graphql`
        {
          site {
            siteMetadata {
              title
            }
          }
          menu: allContentfulNavigations {
            edges {
              node {
                navigationItems {
                  ... on ContentfulLinkItem {
                    contentful_id
                    title
                    slug
                    externalUrl
                  }
                  ... on ContentfulPage {
                    contentful_id
                    title
                    slug
                  }
                }
              }
            }
          }
        }
      `}
      render={({ site, menu: { edges = [{ node: {} }] } }) => (
        <>
          <GlobalStyles />
          <Flex>
            <Background />
            <Box
              width={[1]}
              css={`
                @media (min-width: 1024px) {
                  transform: translateX(0);
                  margin-left: ${theme.posterW.large};
                  min-height: 100vh;
                  flex: auto;
                  overflow-y: auto;
                  overflow-x: hidden;
                }
              `}
            >
              <Link css={{ pointerEvents: "auto" }} to="/" title="PLX">
                <Marquee>PLX TJÄRÖ 2021 ~ 19-22 AUG /</Marquee>
              </Link>
              <Box px={noPadding ? [] : [3, 3, 4]}>{children}</Box>
            </Box>
            <Menu
              invertLogo={invertMenuLogo}
              title={site.siteMetadata.title}
              items={edges[0]?.node?.navigationItems ?? []}
            />
          </Flex>
        </>
      )}
    />
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  invertMenuLogo: PropTypes.bool,
};

export default Layout;
